
import React from "react";
import UserProfileCard from "./UserProfileCard";
import { Button } from "@/components/ui/button";
import { RefreshCw, Users } from "lucide-react";
import { Profile } from "@/hooks/dashboard/useUserProfilesData";
import { User } from "@supabase/supabase-js";

interface UserListProps {
  users: Profile[];
  followingMap: Record<string, boolean>;
  currentUser: User | null;
  onFollow: (userId: string) => void;
  onMessage: (userId: string, username: string | null) => void;
  onViewProfile: (userId: string) => void;
  onRefresh: () => void;
}

const UserList: React.FC<UserListProps> = ({ 
  users, 
  followingMap, 
  currentUser, 
  onFollow, 
  onMessage,
  onViewProfile,
  onRefresh 
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Users className="h-4 w-4" />
          <span>{users.length} amazing people to connect with</span>
        </div>
        <Button 
          variant="ghost" 
          size="sm"
          onClick={onRefresh}
          className="text-xs hover:bg-muted/50 transition-colors"
        >
          <RefreshCw className="h-3 w-3 mr-1" />
          Refresh
        </Button>
      </div>
      
      {users.map((profile, index) => (
        <UserProfileCard
          key={profile.id}
          profile={profile}
          index={index}
          isFollowing={!!followingMap[profile.id]}
          currentUser={currentUser}
          onFollow={onFollow}
          onMessage={onMessage}
          onViewProfile={onViewProfile}
        />
      ))}
    </div>
  );
};

export default UserList;
